import useEffectiveWorkflowRunFilters from '@UI/Pages/WorkflowRuns/Hooks/useEffectiveWorkflowRunFilters';
import workflowRunFiltersSignal, {
	setWorkflowRunFilters,
} from '@UI/Pages/WorkflowRuns/Filters/Signals/workflowRunFiltersSignal';
import formFieldStylesPt from '@UI/Pages/WorkflowRuns/Filters/Helpers/formFieldStylesPt';
import * as React from 'react';
import type { WorkflowRunPeriod } from '@UI/Pages/WorkflowRuns/Filters/WorkflowRunFilterView';
import { Dropdown } from '@verclam/ui-kit';

/** Frozen labels for the period presets — a lookup table, not a decision: the server owns every other option. */
const PERIOD_OPTIONS: ReadonlyArray<{ readonly value: WorkflowRunPeriod; readonly label: string }> =
	Object.freeze([
		{ value: 'all', label: 'Toute période' },
		{ value: 'today', label: "Aujourd'hui" },
		{ value: 'last7Days', label: '7 derniers jours' },
		{ value: 'last30Days', label: '30 derniers jours' },
		{ value: 'custom', label: 'Dates libres' },
	]);

const PeriodFilter: React.FC = () => {
	const filters = useEffectiveWorkflowRunFilters();

	const handlePeriodChange = React.useCallback((period: WorkflowRunPeriod | null) => {
		if (period === null) {
			return;
		}

		setWorkflowRunFilters(workflowRunFiltersSignal.peek().setPeriod(period, new Date()));
	}, []);

	return (
		<Dropdown<WorkflowRunPeriod>
			name="workflowRunPeriod"
			label="Période"
			options={[...PERIOD_OPTIONS]}
			optionLabel="label"
			optionValue="value"
			value={filters.period}
			onChange={handlePeriodChange}
			pt={formFieldStylesPt}
		/>
	);
};

export default PeriodFilter;
